// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonBadge_container__5ddPQ","buttonBadge":"ButtonBadge_buttonBadge__5Gw_6"};